import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next'; // Import the I18nextProvider
import i18n from './i18n'; // Import your i18n configuration
import InfoPage from './components/pages/InfoPage';
import './App.css';
import './util/colors.css'
import theme from './theme';
import InvoiceFormPage from './components/pages/InvoiceFormPage';
import ThankyouPage from './components/pages/ThankyouPage';
import ErrorPage from './components/pages/ErrorPage'; // Import your ErrorPage component
import { ErrorProvider } from './provider/ErrorProvider';
import { GlobalStateProvider } from './provider/GlobalStateProvider';

const App: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n}> {/* Wrap your application with the I18nextProvider */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStateProvider>
          <ErrorProvider> {/* Wrap your application with ErrorProvider */}
            <Router>
              <div className="App" style={{
                height: '100vh', backgroundColor: 'var(--mainBackground)',
                display: 'flex', justifyContent: 'center', flexDirection: 'column'
              }}>
                <Routes>
                  <Route path="/" element={<InfoPage />} />
                  <Route path="/invoiceForm/:id" element={<InvoiceFormPage />} />
                  <Route path="/invoiceForm/thankyou" element={<ThankyouPage />} />
                  <Route path="*" element={<ErrorPage />} />
                </Routes>
              </div>
            </Router>
          </ErrorProvider>
        </GlobalStateProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;